<mat-card class="mb-25 tagus-card" [class.component-dark-theme]="themeService.isDark()"
    [class.component-rtl-enabled]="themeService.isRTLEnabled()">
    <mat-card-header>
    </mat-card-header>
    <mat-card-content>
        <div class="all-projects-table table-responsive" *ngIf="drive_document_list?.length">
            <table class="table">
                <thead>
                    <tr>
                        <th class="fw-semibold main-color text-start">Name</th>
                        <!-- <th class="fw-semibold gray-color text-start">Owner</th> -->
                        <th class="fw-semibold gray-color text-start" *ngIf="drive_type === fmanager_module_ids.share_with_me">Shared by</th>
                        <th class="fw-semibold gray-color text-start">Date</th>
                        <th class="fw-semibold gray-color text-start"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let document of drive_document_list">
                        <td class="text-start">
                            <div class="projects-name d-flex align-items-center">
                                <div class="img me-10" *ngIf="document?.icon">
                                    <img src="assets/img/icon/{{document?.icon}}" alt="icon1">
                                </div>
                                <div class="img me-20" *ngIf="!document?.icon">
                                    <img src="assets/img/icon/doc.png" alt="icon1">
                                </div>
                                <h5 class="fw-semibold mb-0" [ngClass]="{'ms-0': !document?.icon}">
                                    <ng-container *ngIf="drive_type !== fmanager_module_ids.share_with_me">
                                        <ng-container *ngIf="document?.allotment === '4'; else no_imp">
                                            <i class="flaticon-star-1 me-5 cursor-pointer"
                                                (click)="important(drive_action_type.unimportant, document)"></i>
                                        </ng-container>
                                        <ng-template #no_imp>
                                            <i class="flaticon-star me-5 cursor-pointer"
                                                (click)="important(drive_action_type.important, document)"></i>
                                        </ng-template>
                                    </ng-container>
                                    <ng-container *ngIf="document?.type === drive_action_type.folder; else show_file">
                                        <a href="javascript:void(0)" (click)="navigateToFolders(document)"
                                            [matTooltip]="document?.name?.length > 20 ? document?.name : ''">
                                            <ng-container *ngIf="document?.name?.length > 20; else small_name">
                                                {{document?.name | slice:0:20}}<span>...</span>
                                            </ng-container>
                                            <ng-template #small_name>
                                                {{document?.name}}
                                            </ng-template>
                                        </a>
                                    </ng-container>
                                    <ng-template #show_file>
                                        <!-- <a href="javascript:void(0)" (click)="download(document)"
                                            [matTooltip]="document?.name?.length > 20 ? document?.name : ''">
                                            <ng-container *ngIf="document?.name?.length > 20; else small_name">
                                                {{document?.name | slice:0:20}}<span>...</span>
                                            </ng-container>
                                            <ng-template #small_name>
                                                {{document?.name}}
                                            </ng-template>
                                        </a> -->
                                        <a href="javascript:void(0)" (click)="download(document)">
                                             {{document?.name}} 
                                        </a>
                                    </ng-template>
                                </h5>
                                <div class="me-20 count-list">
                                    <span  *ngIf="document?.type === drive_action_type.folder">
                                        {{document?.count|| 0}} Files
                                    </span>
                                </div>
                            </div>
                            
                        </td>
                        <!-- <td class="gray-color text-start">{{'-'}}</td> -->
                        <td *ngIf="drive_type === fmanager_module_ids.share_with_me">
                            <div class="d-flex align-items-center">
                                <ng-container *ngFor="let share_user of document?.shareUsers; index as i">
                                    <ng-container *ngIf="share_user?.initial && share_user?.id !== user_details?.id">
                                        <div class="
                                            rounded-circle justify-content-center 
                                            bg-gray align-items-center d-flex 
                                            fw-semibold main-color text-center 
                                            w-35 h-35 avtar-div fs-12" *ngIf="i <= 2"
                                            [matTooltip]="share_user?.name + (share_user?.role)">
                                                {{share_user?.initial}}
                                        </div>
                                        <div class="
                                            rounded-circle justify-content-center 
                                            bg-gray align-items-center d-flex 
                                            fw-semibold gray-color text-center 
                                            w-35 h-35 fs-12" *ngIf="i === 3" [matMenuTriggerFor]="applicant_menu">
                                            +{{share_user?.remain_count}}
                                        </div>
                                    </ng-container>
                                </ng-container>
                                <mat-menu class="menu-dropdown search-menu" #applicant_menu="matMenu" xPosition="before">
                                    <ul class="menu-body">
                                        <ng-container *ngFor="let share_user of document?.shareUsers">
                                            <li class="position-relative" *ngIf="share_user?.id !== user_details?.id">
                                                <div class="d-flex">
                                                    <div class="title">
                                                        <h5 class="mb-0 fw-semibold ps-0 fs-13">
                                                            {{share_user?.name}} {{share_user?.role}}
                                                        </h5>
                                                    </div>
                                                </div>
                                            </li>
                                        </ng-container>
                                    </ul>
                                </mat-menu>
                            </div>
                        </td>
                        <td class="gray-color text-start">
                            <!-- <span class="badge fw-medium">{{document?.timestamp}}</span> -->
                            {{ document?.createdAt | date: 'MMM d, y, h:mm a' }}
                        </td>
                        <td class="gray-color text-end">
                            <ng-container *ngIf="drive_type === fmanager_module_ids.share_with_me">
                                <ng-container *ngIf="document?.allotment === '4'; else no_imp">
                                    <i class="ri-star-fill me-10 fs-20 cursor-pointer"
                                        (click)="important(drive_action_type.unimportant, document)"></i>
                                </ng-container>
                                <ng-template #no_imp>
                                    <i class="ri-star-line me-10 fs-20 cursor-pointer"
                                        (click)="important(drive_action_type.important, document)"></i>
                                </ng-template>
                            </ng-container>
                            <i class="ri-download-2-line me-10 fs-20 cursor-pointer" 
                                *ngIf="document?.type !== drive_action_type.folder" 
                                (click)="download(document)"></i>
                            <i class="ri-share-line fs-20 cursor-pointer"
                                *ngIf="drive_title !== drive_titles.shared_with_me"
                                (click)="share(drive_action_type.share, document)"></i>
                                <button
                                mat-icon-button
                                [matMenuTriggerFor]="menu"
                                class="p-0 bg-transparent border-none"
                            >
                                <i class="ri-more-fill"></i>
                            </button>
                            <mat-menu #menu="matMenu" class="dotMenu monthMenu">
                                <button
                                    mat-menu-item
                                    (click)="renameDocument(document)"
                                >
                                    <i class="ri-edit-line"></i> Rename
                                </button>
                                <button
                                    mat-menu-item
                                    (click)="deleteDocument(document)"
                                >
                                    <i class="ri-delete-bin-line"></i> Remove
                                </button>
                            </mat-menu>
                        </td>
                    </tr>
                </tbody>
            </table>
            <mat-paginator *ngIf="pagination_config.total > 10" [pageSize]="pagination_config.size"
                [pageSizeOptions]="[10, 20, 50, 100]" showFirstLastButtons [length]="pagination_config.total"
                (page)="pagination($event)">
            </mat-paginator>
        </div>
        <div class="text-center w-100 p-20" *ngIf="!is_loading && !drive_document_list?.length">
            <h6 class="text-center">No Data Found</h6>
        </div>
        <div class="text-center w-100 p-20" *ngIf="is_loading">
            <h6 class="text-center">Loading...</h6>
        </div>
    </mat-card-content>
</mat-card>